import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Assuming custom styles are added here

const MerchantTypes = () => {
  const tableRef = useRef(null); // Ref for DataTable
  const [showForm, setShowForm] = useState(false); // Show/hide left form box
  const [selectedMerchantType, setSelectedMerchantType] = useState(null); // Selected for edit
  const [merchantTypes, setMerchantTypes] = useState([
    { merchantType: "Private", status: "Active", id: 1 },
    { merchantType: "Government", status: "Inactive", id: 2 },
  ]);

  const [formData, setFormData] = useState({
    merchantType: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      // Destroy existing table before re-init to avoid errors
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [merchantTypes]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedMerchantType) {
      setMerchantTypes(
        merchantTypes.map((m) =>
          m.id === selectedMerchantType.id ? { ...formData, id: m.id } : m
        )
      );
    } else {
      setMerchantTypes([
        ...merchantTypes,
        { ...formData, id: merchantTypes.length ? merchantTypes[merchantTypes.length - 1].id + 1 : 1 },
      ]);
    }
    setShowForm(false);
    setFormData({ merchantType: "", status: "Active" });
    setSelectedMerchantType(null);
  };

  const handleEdit = (merchantType) => {
    setSelectedMerchantType(merchantType);
    setFormData({
      merchantType: merchantType.merchantType,
      status: merchantType.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedMerchantType(null);
    setFormData({ merchantType: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="merchant-type-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left side form box */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedMerchantType ? "Edit Merchant Type" : "Add Merchant Type"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Merchant Type:</label>
              <input
                type="text"
                name="merchantType"
                value={formData.merchantType}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Right side table box */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Merchant Types</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Merchant Type
            </button>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="table table-bordered display"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Merchant Type</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {merchantTypes.map((merchantType) => (
                  <tr key={merchantType.id}>
                    <td>{merchantType.merchantType}</td>
                    <td>
                      <span
                        className={`badge ${
                          merchantType.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {merchantType.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(merchantType)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantTypes;
